import pipelineNotInCluster from './shared/pipelineNotInCluster';

export default function isNotDeployed(ionPipeline, controlPipeline) {
  const hasNoIonIntegrations = ionPipeline.pipelineIntegrations.length === 0;
  const pipelineNotDeployed = pipelineNotInCluster(controlPipeline);

  return Boolean(hasNoIonIntegrations && pipelineNotDeployed);
}
